import React from 'react'
import { Skeleton } from 'antd'
import './Loader.styles.scss'

const PaymentReviewLoader: React.FC = () => {
  return (
    <div
      style={{
        display: 'grid',
        gap: '3rem',
        paddingTop: '2%',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '10%',
          width: '80%',
        }}
      >
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '10%',
          width: '80%',
        }}
      >
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '10%',
          width: '80%',
        }}
      >
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          gap: '20%',
          width: '80%',
          paddingLeft: '10%',
          paddingTop: '30px',
        }}
      >
        <Skeleton.Button active size="default" shape="square" style={{ width: '95%' }} />
        <Skeleton.Button active size="default" shape="square" style={{ width: '100%' }} />
      </div>
    </div>
  )
}

export default PaymentReviewLoader
